import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-selectaccount",
  templateUrl: "./selectaccount.page.html",
  styleUrls: ["./selectaccount.page.scss"],
})
export class SelectaccountPage implements OnInit {
  selectedAccount: any;
  accounts: any;
  wallet_id: number;
  math: any = Math;

  pan_number: string;
  bank_account_number: string;
  bank_account_ifsc: string;

  constructor(
    private modalCtrl: ModalController,
    public navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.accounts = this.navParams.get("accounts");
    this.wallet_id = this.navParams.get("wallet_id");
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss(null);
  }

  selectAccount(event: any, index: number) {
    if (event.target.checked) {
      //console.log("unchecked");
      this.selectedAccount = null;
    } else {
      //console.log("checked");
      this.selectedAccount = this.accounts[index];
    }
  }

  async linkAccount() {
    //console.log(this.selectedAccount);
    //console.log("came here");
    if (this.selectedAccount !== null && this.selectedAccount !== undefined) {
      await this.alertandLoading.presentLoading("Adding KYC account to wallet");
      let data = {
        account_id: this.selectedAccount.account_id,
        wallet_id: this.wallet_id,
      };
      this.api.linkAccount(data).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();
          if (!result.error) {
            //data
            //console.log(result);
            this.modalCtrl.dismiss(result.data.account);
          } else {
            this.alertandLoading.showAlert(
              "Alert",
              "Oops something went wrong please try again"
            );
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
          console.log(error);
          this.alertandLoading.showAlert(
            "Alert",
            "Oops something went wrong please try again"
          );
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Alert",
        "Please select an account to verify"
      );
    }
  }

  async createAccount() {
    if (
      this.pan_number !== null &&
      this.pan_number !== "" &&
      this.bank_account_number !== "" &&
      this.bank_account_number !== null &&
      this.bank_account_ifsc !== "" &&
      this.bank_account_ifsc !== null
    ) {
      await this.alertandLoading.presentLoading(
        "Verifying KYC information please wait"
      );

      let data = {
        pan_number: this.pan_number,
        bank_account_number: this.bank_account_number,
        bank_account_ifsc: this.bank_account_ifsc,
      };
      this.api.createAccount(data).then(
        (result: any) => {
          if (!result.error) {
            let data = {
              account_id: result.data.account.account_id,
              wallet_id: this.wallet_id,
            };
            this.api.linkAccount(data).then(
              (res: any) => {
                this.alertandLoading.dismissLoading();
                if (!res.error) {
                  //data
                  //console.log(result);
                  this.modalCtrl.dismiss(res.data.account);
                } else {
                  this.alertandLoading.showAlert(
                    "Alert",
                    "Oops something went wrong please try again"
                  );
                }
              },
              (error: any) => {
                this.alertandLoading.dismissLoading();
                console.log(error);
                this.alertandLoading.showAlert(
                  "Alert",
                  "Oops something went wrong please try again"
                );
              }
            );
          } else {
            this.alertandLoading.dismissLoading();
            this.alertandLoading.showAlert(
              "Alert",
              "Please enter valid information and try again"
            );
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
          console.log(error);
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Alert",
        "Please enter valid information and try again"
      );
    }
  }
}
